import Vue from 'vue';

const success = (response, context) => {
  context.bookingsChecking = response.data.bookings_checking;
  context.bookingsCheckout = response.data.bookings_checkout;
  context.bookingsToday = response.data.bookings_today;
  context.currentGuests = response.data.current_guests;
  context.lastBookings = response.data.last_bookings;
  context.rentals = response.data.rentals;
  context.selectedRental = context.rentals[0].id;
  context.user = response.data.user_rights;
  context.loading = false;
};

const failed = (error, context) => {
  context.loading = false;
  context.showToasterError(error);
};

export default (context, rentalIds) => {
  return Vue.$http.get(`/get-current-bookings?rentalIds=${rentalIds}`)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/getCurrentBookings.js